import React from "react"
import HeaderSideNav from "../HeaderSideNav"

export default function index(props) {
  return <HeaderSideNav name={process.env.REACT_APP_NAME_SYSTEM}>{props.children}</HeaderSideNav>
}
